<mat-dialog-content class="auth-disclaimer-text-center" [@snFadeInDown]>
    <main class="auth-disclaimer-p-sm">
      <h3 class="header">{{complianceTitle}}</h3>
      <ng-template [ngIf]="complianceMessage">
          <div [innerHTML]="complianceMessage"></div>
        </ng-template>
    </main>

  <mat-dialog-actions>
    <button mat-button color="success" (click)="acceptedDisclaimer()">I agree</button>
    <button mat-button color="danger" (click)="logOut()">Close</button>
  </mat-dialog-actions>
</mat-dialog-content>
